// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3VI2z","colBig":"styles_colBig__1HcD0","colSmall":"styles_colSmall__25Hm4"};